<div id="app" class="app app-content-full-height app-without-sidebar app-without-header">
  <div id="content" class="app-content p-0">
    <div class="pos pos-vertical pos-with-header">
      <div class="pos-container" [ngClass]="isMobile ? 'p-2' : 'p-5'">
        <app-header></app-header>

        <div class="content__filter mb-3">
          <div class="d-flex flex-column flex-lg-row align-items-lg-center justify-content-between gap-3">
            <div>
              <span class="fs-3 fw-bold d-block">{{title}}</span>
              <small class="text-muted d-block">
                Shift #{{ currentShiftId || '-' }} · Start {{ currentShiftStartDisplay }}
              </small>
            </div>
            <div class="d-flex gap-2">
              <button class="btn btn-default fw-semibold" (click)="load()">
                <i class="fa fa-sync me-1"></i>
                Refresh
              </button>
              <button class="btn btn-default bg-primary text-white fw-semibold" (click)="addWastage(); $event.stopPropagation()">
                <i class="fa fa-plus me-1"></i>
                Quick Add
              </button>
            </div>
          </div>
        </div>

        <div class="content__body" *ngIf="hasActiveShift">
          <div class="wastage-summary-grid mb-3">
            <div class="summary-card">
              <div class="summary-card__label">Total Records</div>
              <div class="summary-card__value">{{ totalRecords }}</div>
            </div>
            <div class="summary-card">
              <div class="summary-card__label">Total Quantity</div>
              <div class="summary-card__value">{{ totalQuantity | number: '1.2-2' }}</div>
            </div>
            <div class="summary-card summary-card--danger">
              <div class="summary-card__label">Total Amount (RM)</div>
              <div class="summary-card__value">{{ totalAmount | number: '1.2-2' }}</div>
            </div>
          </div>

          <div class="wastage-table-card">
            <div class="table-responsive">
              <table class="table table-bordered bg-white mb-0">
                <thead>
                <tr>
                  <th>No</th>
                  <th>Occurred</th>
                  <th>Item</th>
                  <th class="text-end">Qty</th>
                  <th class="text-end">Unit Price</th>
                  <th class="text-end">Total (RM)</th>
                  <th>Reason / Remark</th>
                  <th>Staff</th>
                  <th class="text-center">Action</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let row of wastages; let i = index; trackBy: trackByWastageId">
                  <td class="w-80px">{{ i + 1 }}</td>
                  <td class="w-200px">{{ row?.occurredAtDisplay }}</td>
                  <td class="w-300px text-wrap fw-semibold">{{ row?.itemName }}</td>
                  <td class="text-end">{{ row?.quantity | number: '1.2-2' }}</td>
                  <td class="text-end">{{ row?.unitPrice | number: '1.2-2' }}</td>
                  <td class="text-end text-danger fw-semibold">{{ row?.totalAmount | number: '1.2-2' }}</td>
                  <td class="w-300px text-wrap">
                    <div class="fw-semibold">{{ row?.reason || '-' }}</div>
                    <small class="text-muted d-block mt-1" *ngIf="row?.remark">{{ row?.remark }}</small>
                  </td>
                  <td>{{ row?.createdByName || '-' }}</td>
                  <td class="text-center">
                    <div class="d-flex justify-content-center gap-2">
                      <button
                        class="btn btn-sm btn-default"
                        [disabled]="!row?.editableInPos"
                        (click)="editWastage(row); $event.stopPropagation()">
                        Edit
                      </button>
                      <button
                        class="btn btn-sm btn-danger text-white"
                        [disabled]="!row?.editableInPos"
                        (click)="deleteWastage(row); $event.stopPropagation()">
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>

                <tr class="total-row" *ngIf="wastages.length > 0">
                  <td></td>
                  <td></td>
                  <td class="fw-bold text-right">Total</td>
                  <td class="text-end fw-bold">{{ totalQuantity | number: '1.2-2' }}</td>
                  <td></td>
                  <td class="text-end fw-bold text-danger">{{ totalAmount | number: '1.2-2' }}</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>

                <tr *ngIf="wastages.length === 0">
                  <td colspan="9" class="text-center py-5">
                    <div class="empty-state">
                      <i class="fa fa-info-circle me-2"></i>
                      <span>No wastage record for current shift</span>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <small class="text-muted d-block mt-2">POS only allows viewing/editing current active shift records.</small>
        </div>
      </div>
    </div>
  </div>
</div>
